var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33636",
    "data-name": "Group 33636",
    transform: "translate(1 0.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    transform: "translate(0 0.264)",
    fill: "#f96361",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32091",
    "data-name": "Group 32091",
    transform: "translate(4.376 4.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15647",
    "data-name": "Path 15647",
    d: "M0,0V7.425",
    transform: "translate(0) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15648",
    "data-name": "Path 15648",
    d: "M0,0V7.425",
    transform: "translate(5.25) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c4f8c977.svg";
export { ForwardRef as ReactComponent };